var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Header = function () {
    this.$menuToggle = $( '.header__menu-toggle' );
    this.$mainMenu = $( '.main-menu' );
    this.$body = $( 'body' );
};

Header.prototype.init = function () {
    var self = this;

    self.$menuToggle.click( function ( e ) {
        e.preventDefault();
        self.$menuToggle.toggleClass( 'is-active' );
        self.$mainMenu.toggleClass( 'is-open' );
        self.$body.toggleClass( 'no-scroll' );
    } );
};

module.exports = new Header();
